import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=f57fada6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57fada6"]])

export default __exports__